import React, { Component } from 'react';
import { debounce } from 'lodash';

let redDot = "https://maps.google.com/mapfiles/ms/icons/red-dot.png", map;
// , blueDot = "https://maps.google.com/mapfiles/ms/icons/blue-dot.png";

class CustomMap extends Component {
  constructor(props) {
    super(props);
    this.handleGetBounds = this.handleGetBounds.bind(this);
  }

  debouncer = debounce((mapBounds) => { this.props.collectNewMapDetails("mapBounds", mapBounds)}, 500);

  loadMarkersDebouncer = debounce((mapBounds) => {this.props.listings && this.loadMarkers()}, 1000);


  handleGetBounds(){
    var mapBounds = map.getBounds();
    this.debouncer(mapBounds)
  }

  componentDidUpdate(){
    if (this.props.listings) {this.loadMarkersDebouncer()}
  }

  componentDidMount() {
    map = new window.google.maps.Map(document.getElementById(this.props.id), this.props.options);
    var marker = new window.google.maps.Marker({position: {lat: -36.842279, lng: 174.7504804}, map: map, label: {text: "", color: "transparent"}, options: {icon: redDot }})
  
    marker.addListener('click', function() {console.log('marker clicked')})
  }

  render() {
    return (
      <div id="GoogleMap">
      </div>
    );
  }
}

export default CustomMap;